export default {"src":"/_next/static/media/500-dark.1b373e0a.svg","height":600,"width":900,"blurWidth":0,"blurHeight":0};